import * as tslib_1 from "tslib";
import { OnInit, ChangeDetectorRef } from '@angular/core';
import { UserSettingsHttpService } from '../../../../../app/core/user-settings';
import { Cache, Auth } from 'aws-amplify';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { NotifyDialogComponent } from './notify-dialog/notify-dialog.component';
import { MixpanelService } from '../../../../services/mixpanel.service';
var NotificationsComponent = /** @class */ (function () {
    function NotificationsComponent(http, cdr, dialog, _snackBar, mixPanelService) {
        this.http = http;
        this.cdr = cdr;
        this.dialog = dialog;
        this._snackBar = _snackBar;
        this.mixPanelService = mixPanelService;
        this.topics = {};
        this.show = 'alerts';
        this.summaryReport = false;
        this.listType = '';
        this.machines = [];
        this.clients = [];
        this.regions = [];
        this.distis = [];
        this.markets = [];
        this.optReg = '';
        this.territories = [];
        this.campuses = [];
        this.optTerr = '';
        this.listOpt = [];
        this.unSubs = false;
        this.dialogConfig = new MatDialogConfig();
        this.addedRegions = [];
        this.addedTerritories = [];
        this.addedMachines = [];
        // Subscriptions tab properties
        this.loadingSubscriptions = false;
        this.analyticsSubscribed = false;
        this.stockoutSubscribed = false;
        this.stockoutMode = 'on-demand';
        this.stockoutIsOnDemand = true; // Boolean for toggle binding
        this.stockoutThreshold = 7;
        this.selectedCampusIds = [];
        this.filteredCampuses = [];
        this.campusSelectOptions = [];
        this.campusDropdownValue = []; // Track dropdown selection separately (will be cleared after adding)
        this.allLoadedCampuses = []; // Keep track of all campuses ever loaded (for displaying selected campuses not in current filter)
        this.loadingCampuses = false;
        this.originalSubscriptionData = null;
        this.userId = null;
        this.hasChanges = false;
        // Distributor selection properties (for superadmin)
        this.selectedDistributorIds = [];
        this.distributorSelectOptions = [];
        this.distributorDropdownValue = [];
        this.loadingDistributors = false;
        this.allDistributors = [];
        // Hierarchical filter properties
        this.hierarchicalFilterParams = {
            disti_id: null,
            market_id: null,
            client_id: null,
            campus_id: null
        };
    }
    NotificationsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.user = Cache.getItem('userAttr');
        this.role = this.user['custom:role'];
        this.getUserAttr();
        this.getDistributors();
        this.getExistingSubs();
        this.topics.errors = [];
        this.topics.warnings = [];
        this.mixPanelService.track(this.mixPanelService.PAGE_VIEW);
        // Initialize subscriptions tab
        this.getUserId().then(function () {
            _this.loadSubscriptions();
        });
        // Load all campuses initially (will be filtered when hierarchical filters change)
        this.loadFilteredCampuses();
        // Load distributors if superadmin
        if (this.role === 'sadmin') {
            this.loadDistributors();
        }
    };
    NotificationsComponent.prototype.getUserAttr = function () {
        var _this = this;
        this.http.getUserAttr()
            .subscribe(function (userDbAttr) {
            _this.userDbAttr = userDbAttr;
            _this.summaryReport = userDbAttr.summary_subs;
        });
    };
    NotificationsComponent.prototype.btnTxt = function () {
        if (this.subs) {
            return 'Update Subscription';
        }
        else {
            return 'Subscribe';
        }
    };
    NotificationsComponent.prototype.subscribe = function () {
        var _this = this;
        var topic_id = [];
        console.log(this.topics.errors);
        for (var _i = 0, _a = this.topics.errors; _i < _a.length; _i++) {
            var eTopic = _a[_i];
            if (eTopic.checked) {
                var topics = (eTopic.log_code.split(','));
                // tslint:disable-next-line: prefer-for-of
                for (var i = 0; i < topics.length; i++) {
                    topic_id.push(topics[i]);
                }
            }
        }
        for (var _b = 0, _c = this.topics.warnings; _b < _c.length; _b++) {
            var wTopic = _c[_b];
            if (wTopic.checked) {
                var topics = (wTopic.log_code).split(',');
                // tslint:disable-next-line: prefer-for-of
                for (var i = 0; i < topics.length; i++) {
                    topic_id.push(topics[i]);
                }
            }
        }
        var postObj = {
            topic_ids: topic_id,
            new: true,
            disti_ids: this.distis,
            market_ids: this.markets,
            client_ids: this.clients,
            campus_ids: this.campuses,
            subs_arn: null
        };
        if (this.subs) {
            postObj.new = false;
            postObj.subs_arn = this.subs.subs_arn;
        }
        // console.log(postObj);
        this.http.postSubscription(postObj)
            .subscribe(function (data) {
            if (!_this.subs) {
                _this.dialogConfig.autoFocus = true;
                _this.dialogConfig.data = {
                    type: 'subs'
                };
                _this.dialogConfig.minWidth = '350';
                var dialogRef = _this.dialog.open(NotifyDialogComponent, _this.dialogConfig);
                dialogRef.afterClosed().subscribe(function (res) {
                    _this.getExistingSubs();
                });
            }
            else {
                _this.showSnackBar('Subscription updated Successfully', 0);
            }
        }, function (error) {
            console.log(error);
        });
    };
    NotificationsComponent.prototype.getExistingSubs = function () {
        var _this = this;
        this.http.getExistingSubsDet()
            .subscribe(function (subs) {
            console.log(subs);
            _this.subs = subs;
            _this.getTopics();
        });
    };
    NotificationsComponent.prototype.sumRepClicked = function () {
        var _this = this;
        this.http.updateSummaryReport(this.summaryReport)
            .subscribe(function (result) {
            if (_this.summaryReport) {
                _this.showSnackBar('Summary Report Subscribed', 6000);
            }
            else {
                _this.showSnackBar('Summary Report Unsubscribed', 6000);
            }
        });
    };
    // getRegions() {
    // 	if (this.role.includes('rmgr')) {
    // 		// this.regions.push(this.user['custom:region_id']);
    // 		this.regions = (this.user['custom:region_id']).split(',');
    // 	} else if (this.role.includes('admin')) {
    // 		this.http.getRegions()
    // 		.subscribe((regions: any[]) => {
    // 			for (let reg of regions) {
    // 					this.regions.push(reg.region_id);
    // 			}
    // 		});
    // 	}
    // }
    NotificationsComponent.prototype.getDistributors = function () {
        if (this.role == 'sadmin') {
            this.distis = [];
            // this.http.getDistis()
            // .subscribe((distis: any[]) => {
            // 	for(let dist of distis)
            // 		this.distis.push(dist.disti_id);
            // });
        }
        else {
            console.log(this.user);
            this.distis = (this.user['custom:disti_id']).split(',');
            this.getMarkets();
            this.getClients();
        }
    };
    NotificationsComponent.prototype.getMarkets = function () {
        if (this.user['custom:market_id']) {
            this.markets = (this.user['custom:market_id']).split(',');
        }
    };
    NotificationsComponent.prototype.getClients = function () {
        if (this.user['custom:client_id']) {
            this.clients = (this.user['custom:client_id']).split(',');
            this.getCampus();
        }
    };
    NotificationsComponent.prototype.getCampus = function () {
        if (this.user['custom:campus_id']) {
            this.campuses = (this.user['custom:campus_id']).split(',');
        }
    };
    NotificationsComponent.prototype.getTopics = function () {
        var _this = this;
        this.topics.errors = [];
        this.topics.warnings = [];
        this.http.getTopics()
            .subscribe(function (data) {
            console.log(data);
            for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                var item = data_1[_i];
                if (item.log_msg.includes(' error occurred')) {
                    item.log_msg = item.log_msg.replace(' error occurred', '');
                }
                if (item.log_msg.includes(' warning occurred')) {
                    item.log_msg = item.log_msg.replace(' warning occurred', '');
                }
                if (item.disp) {
                    if (item.log_code.startsWith('e0')) {
                        if (_this.subs) {
                            if (!_this.subs.event_codes.includes(item.log_code)) {
                                _this.topics.errors.push({ log_code: item.log_code, log_msg: item.log_msg, checked: false });
                            }
                            else {
                                _this.unSubs = true;
                                _this.topics.errors.push({ log_code: item.log_code, log_msg: item.log_msg, checked: true });
                            }
                        }
                        else {
                            _this.topics.errors.push({ log_code: item.log_code, log_msg: item.log_msg, checked: false });
                        }
                    }
                    else if (item.log_code.startsWith('w0')) {
                        if (item.log_code != 'w000001' || _this.role == 'sadmin') {
                            if (_this.subs) {
                                if (!_this.subs.event_codes.includes(item.log_code)) {
                                    _this.topics.warnings.push({ log_code: item.log_code, log_msg: item.log_msg, checked: false });
                                }
                                else {
                                    _this.unSubs = true;
                                    _this.topics.warnings.push({ log_code: item.log_code, log_msg: item.log_msg, checked: true });
                                }
                            }
                            else {
                                _this.topics.warnings.push({ log_code: item.log_code, log_msg: item.log_msg, checked: false });
                            }
                        }
                    }
                }
                // else {
                // 	if (this.role.includes('admin')) {
                // 		if (item.log_code.startsWith('e0')) {
                // 			this.topics.errors.push({log_code: item.log_code, log_msg: item.log_msg, checked: false});
                // 		} else if (item.log_code.startsWith('w0')) {
                // 			this.topics.warnings.push({log_code: item.log_code, log_msg: item.log_msg, checked: false});
                // 		}
                // 	}
                // }
            }
            _this.cdr.detectChanges();
        });
    };
    NotificationsComponent.prototype.checkBoxClicked = function () {
        if (JSON.stringify(this.topics).includes('true')) {
            this.unSubs = true;
        }
        else {
            this.unSubs = false;
        }
    };
    NotificationsComponent.prototype.clearAll = function () {
        for (var _i = 0, _a = this.topics.errors; _i < _a.length; _i++) {
            var eTopic = _a[_i];
            eTopic.checked = false;
        }
        for (var _b = 0, _c = this.topics.warnings; _b < _c.length; _b++) {
            var wTopic = _c[_b];
            wTopic.checked = false;
        }
        this.unSubs = false;
    };
    NotificationsComponent.prototype.unSubscribe = function () {
        var _this = this;
        if (this.subs) {
            this.dialogConfig.autoFocus = true;
            this.dialogConfig.data = {
                type: 'unSubs'
            };
            this.dialogConfig.minWidth = '350';
            var dialogRef = this.dialog.open(NotifyDialogComponent, this.dialogConfig);
            dialogRef.afterClosed().subscribe(function (res) {
                if (!res) {
                    return;
                }
                else {
                    if (res.success) {
                        // Unsubscribe from all alert
                        var postObj = {
                            topic_ids: [],
                            new: false,
                            machine_ids: [],
                            disti_ids: _this.distis,
                            market_ids: _this.markets,
                            client_ids: _this.clients,
                            campus_ids: _this.campuses,
                            subs_arn: _this.subs.subs_arn
                        };
                        console.log(postObj);
                        _this.http.postSubscription(postObj)
                            .subscribe(function (data) {
                            console.log(data);
                            _this.getExistingSubs();
                            _this.showSnackBar('Unsubscribed Successfully', 0);
                            _this.cdr.detectChanges();
                        }, function (error) {
                            _this.showSnackBar('Unable to unsubscribe', 0);
                            console.log(error);
                        });
                    }
                }
            });
        }
    };
    NotificationsComponent.prototype.enableLoadDialog = function () {
        this.dialogConfig.data = {
            type: 'load'
        };
        this.loadDialog = this.dialog.open(NotifyDialogComponent, this.dialogConfig);
    };
    NotificationsComponent.prototype.disableLoadDialog = function () {
        if (this.loadDialog) {
            this.loadDialog.close();
        }
    };
    /**
  * @param message Message to display in snackbar.
  * @param duration No of seconds to show, If 0 it will not disappear.
  */
    NotificationsComponent.prototype.showSnackBar = function (message, duration) {
        var _this = this;
        var snackRef = this._snackBar.open(message, 'close');
        if (duration > 0) {
            setTimeout(function () {
                _this._snackBar.dismiss();
            }, duration);
        }
        snackRef.onAction().subscribe(function () {
            _this._snackBar.dismiss();
        });
    };
    // Subscriptions tab methods
    NotificationsComponent.prototype.getUserId = function () {
        var _this = this;
        return Auth.currentAuthenticatedUser()
            .then(function (user) {
            if (user && user.attributes && user.attributes.sub) {
                _this.userId = user.attributes.sub;
                console.log('User ID loaded:', _this.userId);
            }
            else if (user && user.username) {
                // Fallback to username if sub is not available
                _this.userId = user.username;
                console.log('Using username as userId:', _this.userId);
            }
            else {
                console.error('Could not get user ID from authenticated user');
            }
        })
            .catch(function (err) {
            console.error('Error getting authenticated user:', err);
            // Try currentUserInfo as fallback
            return Auth.currentUserInfo()
                .then(function (userInfo) {
                if (userInfo && userInfo.attributes && userInfo.attributes.sub) {
                    _this.userId = userInfo.attributes.sub;
                    console.log('User ID loaded from currentUserInfo:', _this.userId);
                }
                else {
                    console.error('Could not get user ID from currentUserInfo either');
                }
            })
                .catch(function (error) {
                console.error('Error getting user info:', error);
            });
        });
    };
    NotificationsComponent.prototype.loadSubscriptions = function () {
        var _this = this;
        if (!this.userId) {
            console.warn('Cannot load subscriptions: userId not available');
            return;
        }
        this.loadingSubscriptions = true;
        console.log('Loading subscriptions for userId:', this.userId);
        this.http.getNotifications(this.userId)
            .subscribe(function (data) {
            _this.loadingSubscriptions = false;
            console.log('Subscriptions data received:', data);
            if (data === null || !data) {
                // No subscription exists, treat as both disabled
                _this.analyticsSubscribed = false;
                _this.stockoutSubscribed = false;
                _this.stockoutMode = 'on-demand';
                _this.stockoutIsOnDemand = true;
                _this.stockoutThreshold = 7;
                _this.selectedCampusIds = [];
                if (_this.role === 'sadmin') {
                    _this.selectedDistributorIds = [];
                }
                _this.originalSubscriptionData = null;
            }
            else {
                // Map API response to component state
                _this.analyticsSubscribed = data.analyticsSubscribed || false;
                _this.stockoutSubscribed = data.stockoutSubscribed || false;
                // Determine stockout mode based on threshold
                if (data.stockoutAlertThreshold !== null && data.stockoutAlertThreshold !== undefined) {
                    _this.stockoutMode = 'on-demand';
                    _this.stockoutIsOnDemand = true;
                    _this.stockoutThreshold = data.stockoutAlertThreshold;
                }
                else {
                    _this.stockoutMode = 'daily';
                    _this.stockoutIsOnDemand = false;
                    _this.stockoutThreshold = 7;
                }
                // Normalize campus IDs to strings for consistency
                _this.selectedCampusIds = (data.campusIds || []).map(function (id) { return String(id); });
                // Load distributor IDs if available (for superadmin)
                if (_this.role === 'sadmin') {
                    // Handle both distiIds and disti_ids for backward compatibility
                    var distiIds = data.distiIds || data.disti_ids;
                    if (distiIds) {
                        _this.selectedDistributorIds = (distiIds || []).map(function (id) { return String(id); });
                    }
                    else {
                        _this.selectedDistributorIds = [];
                    }
                    // Update dropdown options to exclude selected distributors (only if distributors are loaded)
                    if (_this.allDistributors.length > 0) {
                        _this.updateDistributorSelectOptions();
                    }
                }
                _this.hierarchicalFilterParams = {
                    disti_id: null,
                    market_id: null,
                    client_id: null,
                    campus_id: null
                };
                // Reload campuses without filters to show all available campuses
                _this.loadFilteredCampuses();
                _this.originalSubscriptionData = JSON.parse(JSON.stringify(data));
            }
            _this.checkForChanges();
            _this.cdr.detectChanges();
        }, function (error) {
            _this.loadingSubscriptions = false;
            _this.showSnackBar('Failed to load subscriptions', 0);
            console.error('Error loading subscriptions:', error);
            _this.cdr.detectChanges();
        });
    };
    NotificationsComponent.prototype.onHierarchicalFilterChange = function (params) {
        this.hierarchicalFilterParams = params;
        this.loadFilteredCampuses();
        this.cdr.detectChanges();
    };
    NotificationsComponent.prototype.extractSingleValue = function (value) {
        if (!value) {
            return null;
        }
        var singleValue = Array.isArray(value) ? value[0] : value;
        return singleValue ? String(singleValue) : null;
    };
    NotificationsComponent.prototype.buildCampusQueryParams = function () {
        var queryParams = {};
        var distiId = this.extractSingleValue(this.hierarchicalFilterParams.disti_id);
        if (distiId) {
            queryParams.disti_id = distiId;
        }
        var marketId = this.extractSingleValue(this.hierarchicalFilterParams.market_id);
        if (marketId) {
            queryParams.market_id = marketId;
        }
        var clientId = this.extractSingleValue(this.hierarchicalFilterParams.client_id);
        if (clientId) {
            queryParams.client_id = clientId;
        }
        return queryParams;
    };
    NotificationsComponent.prototype.transformCampuses = function (campuses) {
        return (campuses || []).map(function (campus) { return (tslib_1.__assign({}, campus, { campus_id: String(campus.campus_id) })); });
    };
    /**
     * Merge new campuses into allLoadedCampuses, avoiding duplicates
     */
    NotificationsComponent.prototype.mergeCampusesIntoAllLoaded = function (newCampuses) {
        var _this = this;
        var existingCampusIds = new Set(this.allLoadedCampuses.map(function (c) { return String(c.campus_id); }));
        newCampuses.forEach(function (campus) {
            if (!existingCampusIds.has(String(campus.campus_id))) {
                _this.allLoadedCampuses.push(campus);
            }
        });
    };
    /**
     * Update campusSelectOptions by filtering out already-selected campuses
     */
    NotificationsComponent.prototype.updateCampusSelectOptions = function () {
        var selectedCampusIdsSet = new Set(this.selectedCampusIds.map(function (id) { return String(id); }));
        this.campusSelectOptions = this.filteredCampuses
            .filter(function (campus) { return !selectedCampusIdsSet.has(String(campus.campus_id)); })
            .map(function (campus) { return ({
            value: campus.campus_id,
            label: campus.name
        }); });
    };
    NotificationsComponent.prototype.loadFilteredCampuses = function () {
        var _this = this;
        this.loadingCampuses = true;
        var queryParams = this.buildCampusQueryParams();
        this.http.getCampus(queryParams)
            .subscribe(function (campuses) {
            _this.loadingCampuses = false;
            // Transform and store filtered campuses
            _this.filteredCampuses = _this.transformCampuses(campuses);
            // Merge into allLoadedCampuses for name resolution
            _this.mergeCampusesIntoAllLoaded(_this.filteredCampuses);
            // Update dropdown options (excluding already-selected campuses)
            _this.updateCampusSelectOptions();
            // Ensure dropdown value is always empty (no state stored)
            _this.campusDropdownValue = [];
            _this.checkForChanges();
            _this.cdr.detectChanges();
        }, function (error) {
            _this.loadingCampuses = false;
            console.error('Error loading campuses:', error);
            _this.cdr.detectChanges();
        });
    };
    NotificationsComponent.prototype.onAnalyticsChange = function () {
        this.checkForChanges();
    };
    NotificationsComponent.prototype.onStockoutChange = function () {
        this.checkForChanges();
    };
    NotificationsComponent.prototype.onTabChange = function (event) {
        var _this = this;
        // Load subscriptions when Subscriptions tab is selected (index 1)
        if (event.index === 1 && !this.loadingSubscriptions && !this.originalSubscriptionData) {
            if (this.userId) {
                this.loadSubscriptions();
            }
            else {
                this.getUserId().then(function () {
                    _this.loadSubscriptions();
                });
            }
        }
    };
    NotificationsComponent.prototype.onStockoutModeChange = function () {
        // Update the boolean property based on the mode
        this.stockoutIsOnDemand = this.stockoutMode === 'on-demand';
        if (this.stockoutMode === 'daily') {
            this.stockoutThreshold = 7; // Clear threshold when switching to daily
        }
        this.checkForChanges();
    };
    NotificationsComponent.prototype.onThresholdChange = function () {
        this.checkForChanges();
    };
    NotificationsComponent.prototype.onCampusSelectionChange = function () {
        // Normalize campus IDs to strings for consistency
        this.selectedCampusIds = this.selectedCampusIds.map(function (id) { return String(id); });
        this.checkForChanges();
    };
    /**
     * Handle immediate campus selection change (fires on option click)
     * Adds selected campus to chips immediately and clears dropdown
     */
    NotificationsComponent.prototype.onCampusImmediateSelect = function (values) {
        var _this = this;
        if (values === null) {
            return;
        }
        // Get the selected campus ID (single select mode)
        var campusId = Array.isArray(values) && values.length > 0
            ? String(values[0])
            : String(values);
        // Add to chips if not already selected
        var existingIds = new Set(this.selectedCampusIds.map(function (id) { return String(id); }));
        if (!existingIds.has(campusId)) {
            this.selectedCampusIds = this.selectedCampusIds.concat([campusId]);
            // Remove from dropdown options so it doesn't appear again
            this.campusSelectOptions = this.campusSelectOptions.filter(function (opt) { return String(opt.value) !== campusId; });
            this.checkForChanges();
            this.cdr.detectChanges();
        }
        // Clear dropdown selection immediately
        setTimeout(function () {
            _this.campusDropdownValue = [];
            _this.cdr.detectChanges();
        }, 0);
    };
    /**
     * Handle campus selection change from searchable-select component (fires when dropdown closes)
     * Ensures dropdown is cleared
     */
    NotificationsComponent.prototype.onCampusSelectChange = function (values) {
        // Ensure dropdown is cleared
        this.campusDropdownValue = [];
        this.cdr.detectChanges();
    };
    /**
     * Get display value for campus searchable-select
     */
    NotificationsComponent.prototype.getCampusDisplay = function (selected) {
        if (selected.length === 0) {
            return 'All Campuses';
        }
        if (selected.length <= 3) {
            return selected.map(function (s) { return s.label; }).join(', ');
        }
        return selected.length + ' selected';
    };
    NotificationsComponent.prototype.removeCampus = function (campusId) {
        // Normalize to string for comparison
        var normalizedId = String(campusId);
        this.selectedCampusIds = this.selectedCampusIds.filter(function (id) { return String(id) !== normalizedId; });
        this.checkForChanges();
        this.cdr.detectChanges();
    };
    /**
     * Find a campus in an array by ID (handles string/number ID matching)
     */
    NotificationsComponent.prototype.findCampusById = function (campuses, campusId) {
        if (!campuses || campuses.length === 0) {
            return null;
        }
        var normalizedId = String(campusId);
        return campuses.find(function (c) {
            return String(c.campus_id) === normalizedId ||
                c.campus_id === campusId ||
                Number(c.campus_id) === Number(campusId);
        }) || null;
    };
    /**
     * Get campus name by ID, searching through all loaded campuses
     */
    NotificationsComponent.prototype.getCampusName = function (campusId) {
        if (!campusId) {
            return String(campusId);
        }
        // Try filteredCampuses first (current filter results)
        var campus = this.findCampusById(this.filteredCampuses, campusId);
        if (campus) {
            return campus.name;
        }
        // Try allLoadedCampuses (all campuses ever loaded, including from previous filters)
        campus = this.findCampusById(this.allLoadedCampuses, campusId);
        if (campus) {
            return campus.name;
        }
        // Fallback: return the ID as string if campus not found
        return String(campusId);
    };
    NotificationsComponent.prototype.updateDistributorSelectOptions = function () {
        var selectedDistributorIdsSet = new Set(this.selectedDistributorIds.map(function (id) { return String(id); }));
        // Create new array reference so Angular change detection picks it up
        this.distributorSelectOptions = this.allDistributors
            .filter(function (dist) { return !selectedDistributorIdsSet.has(String(dist.disti_id)); })
            .map(function (dist) { return ({
            value: dist.disti_id,
            label: dist.name
        }); })
            .sort(function (a, b) { return a.label.localeCompare(b.label); }); // Sort alphabetically
    };
    NotificationsComponent.prototype.checkForChanges = function () {
        if (!this.originalSubscriptionData) {
            // If no original data, check if anything is set
            // Note: hasChanges doesn't validate campus selection - that's done on save
            this.hasChanges = this.analyticsSubscribed || this.stockoutSubscribed ||
                (this.stockoutSubscribed && this.selectedCampusIds.length > 0) ||
                (this.stockoutSubscribed && this.stockoutIsOnDemand && this.stockoutThreshold !== 7) ||
                (this.role === 'sadmin' && this.analyticsSubscribed && this.selectedDistributorIds.length > 0);
            return;
        }
        // Compare current state with original
        var original = this.originalSubscriptionData;
        var analyticsChanged = this.analyticsSubscribed !== original.analyticsSubscribed;
        var stockoutChanged = this.stockoutSubscribed !== original.stockoutSubscribed;
        // Compare campus IDs (arrays)
        var originalCampusIds = (original.campusIds || []).map(function (id) { return String(id); }).sort();
        var currentCampusIds = this.selectedCampusIds.map(function (id) { return String(id); }).sort();
        var campusIdsChanged = JSON.stringify(currentCampusIds) !== JSON.stringify(originalCampusIds);
        // Compare threshold and mode
        var originalThreshold = original.stockoutAlertThreshold;
        var originalIsOnDemand = (originalThreshold !== null && originalThreshold !== undefined);
        var thresholdChanged = this.stockoutIsOnDemand !== originalIsOnDemand ||
            (this.stockoutIsOnDemand && this.stockoutThreshold !== originalThreshold);
        // Compare distributor IDs (for superadmin)
        var distributorIdsChanged = false;
        if (this.role === 'sadmin') {
            // Handle both distiIds and disti_ids for backward compatibility
            var originalDistiIds = original.distiIds || original.disti_ids;
            var originalDistributorIds = (originalDistiIds || []).map(function (id) { return String(id); }).sort();
            var currentDistributorIds = this.selectedDistributorIds.map(function (id) { return String(id); }).sort();
            distributorIdsChanged = JSON.stringify(currentDistributorIds) !== JSON.stringify(originalDistributorIds);
        }
        this.hasChanges = analyticsChanged || stockoutChanged || campusIdsChanged || thresholdChanged || distributorIdsChanged;
    };
    NotificationsComponent.prototype.loadDistributors = function () {
        var _this = this;
        if (this.role !== 'sadmin') {
            return;
        }
        this.loadingDistributors = true;
        this.http.getDistis()
            .subscribe(function (distributors) {
            _this.loadingDistributors = false;
            _this.allDistributors = distributors || [];
            // Update dropdown options, excluding any already selected distributors
            _this.updateDistributorSelectOptions();
            _this.cdr.detectChanges();
        }, function (error) {
            _this.loadingDistributors = false;
            console.error('Error loading distributors:', error);
            _this.cdr.detectChanges();
        });
    };
    NotificationsComponent.prototype.onDistributorImmediateSelect = function (values) {
        var _this = this;
        if (values === null) {
            return;
        }
        // Get the selected distributor ID (single select mode)
        var distributorId = Array.isArray(values) && values.length > 0
            ? String(values[0])
            : String(values);
        // Add to chips if not already selected
        var existingIds = new Set(this.selectedDistributorIds.map(function (id) { return String(id); }));
        if (!existingIds.has(distributorId)) {
            this.selectedDistributorIds = this.selectedDistributorIds.concat([distributorId]);
            // Remove from dropdown options so it doesn't appear again
            this.distributorSelectOptions = this.distributorSelectOptions.filter(function (opt) { return String(opt.value) !== distributorId; });
            this.checkForChanges();
            this.cdr.detectChanges();
        }
        // Clear dropdown selection immediately
        setTimeout(function () {
            _this.distributorDropdownValue = [];
            _this.cdr.detectChanges();
        }, 0);
    };
    NotificationsComponent.prototype.onDistributorSelectChange = function (values) {
        // Ensure dropdown is cleared
        this.distributorDropdownValue = [];
        this.cdr.detectChanges();
    };
    NotificationsComponent.prototype.removeDistributor = function (distributorId) {
        // Normalize to string for comparison
        var normalizedId = String(distributorId);
        this.selectedDistributorIds = this.selectedDistributorIds.filter(function (id) { return String(id) !== normalizedId; });
        // Update dropdown options - this creates a new array reference so Angular change detection picks it up
        this.updateDistributorSelectOptions();
        this.checkForChanges();
        this.cdr.detectChanges();
    };
    NotificationsComponent.prototype.getDistributorName = function (distributorId) {
        if (!distributorId) {
            return String(distributorId);
        }
        var distributor = this.allDistributors.find(function (d) { return String(d.disti_id) === String(distributorId); });
        return distributor ? distributor.name : String(distributorId);
    };
    NotificationsComponent.prototype.saveSubscriptions = function () {
        var _this = this;
        if (!this.userId) {
            this.showSnackBar('User ID not available', 0);
            return;
        }
        // Validation: must select at least one campus if subscribing to stockout alerts
        if (this.stockoutSubscribed && (!this.selectedCampusIds || this.selectedCampusIds.length === 0)) {
            this.showSnackBar('Please select at least one campus for stockout alerts', 0);
            return;
        }
        this.loadingSubscriptions = true;
        var payload = {
            user_id: this.userId,
            analytics_subscribed_status: this.analyticsSubscribed,
            stockout_subscribed_status: this.stockoutSubscribed
        };
        if (this.stockoutSubscribed) {
            payload.campus_ids = this.selectedCampusIds;
            payload.stockout_alert_threshold = (this.stockoutMode === 'on-demand')
                ? this.stockoutThreshold
                : null;
        }
        else {
            payload.campus_ids = [];
            payload.stockout_alert_threshold = null;
        }
        // Add distributor IDs for superadmin analytics subscription
        if (this.role === 'sadmin' && this.analyticsSubscribed) {
            payload.disti_ids = this.selectedDistributorIds;
        }
        this.http.updateNotifications(payload)
            .subscribe(function (response) {
            _this.loadingSubscriptions = false;
            _this.showSnackBar('Subscriptions updated successfully', 0);
            // Reload subscriptions to update originalSubscriptionData
            _this.loadSubscriptions();
        }, function (error) {
            _this.loadingSubscriptions = false;
            var errorMessage = (error.error && error.error.error) || error.message || 'Failed to update subscriptions';
            _this.showSnackBar(errorMessage, 0);
            console.error('Error updating subscriptions:', error);
            _this.cdr.detectChanges();
        });
    };
    return NotificationsComponent;
}());
export { NotificationsComponent };
